import { SearchListingsOutput, ISearchListingsOutputProps } from "artifacts/SearchListingsOutput";

// Thin wrapper around SearchListingsOutput that uses the correct artifact key
// for the search_similar_nearby_homes_tool backend tool.
SearchSimilarNearbyHomesOutput.artifactKey = "search_similar_nearby_homes";
SearchSimilarNearbyHomesOutput.asText = SearchListingsOutput.asText;

export function SearchSimilarNearbyHomesOutput(
    props: ISearchListingsOutputProps
): JSX.Element {
    // Paging for these results is driven by the model re-calling
    // search_similar_nearby_homes_tool with an advanced `start`, not by the
    // carousel's own tile: that tile dispatches a `search_listings` next-page
    // operation, which would drop the similar / nearby context entirely (and no
    // operation model is registered under this tool's name to receive it).
    return SearchListingsOutput({ ...props, hideLoadMore: true });
}
